import { CometChatAvatar, CometChatUIKitLoginListener, getLocalizedString } from '@cometchat/chat-uikit-react';
import '../../styles/CometChatDetails/CometChatUserDetails.css';
import React, { useContext, useEffect, useState } from 'react';
import { useCometChatContext } from '../../context/CometChatContext';
import { AppContext } from '../../context/AppContext';
import { ArrowLeft } from 'lucide-react';
import { toast } from "react-toastify";

interface UserDetailProps {
  user: CometChat.User;
  onHide?: () => void;
  actionItems?: {
    id?: string;
    name: string;
    icon: string;
  }[];
  showStatus?: boolean;
  onUserActionClick?: (item: { name: string; icon: string }) => void;
}
interface ExtendedUser extends CometChat.User {
  role?: string;
}

export const CometChatUserDetails = (props: UserDetailProps) => {
  const { user, onHide = () => {}, actionItems = [], showStatus, onUserActionClick = () => {} } = props;
  const { chatFeatures } = useCometChatContext();
  const { appState } = useContext(AppContext);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const avatar = user.getAvatar?.(); // ✅ define first
  const hasAvatar = Boolean(avatar);

  const handleAvatarClick = () => {
    if (!hasAvatar) {
      toast.info("This user hasn’t set a profile photo");
      return;
    }
    setIsPreviewOpen(true);
  };

  const [loggedInUserRole, setLoggedInUserRole] = useState<CometChat.User | null>(null);
  // console.log("comectchat messages loggedInUserRole->", loggedInUserRole);

  useEffect(() => {
    const user = CometChatUIKitLoginListener.getLoggedInUser();
    setLoggedInUserRole(user);
  }, []);

  const getRoleLabel = (role: any) => {
    switch(role) {
      case "manager":
        return "(RA)";
      case "lc":
        return "(LC)";
      default:
        return "(Client)";
    }
  };

  const extendedUser = user as ExtendedUser;

  return (
    <>
      <div className="cometchat-user-details__header">
        <div className="cometchat-user-details__header-text">{getLocalizedString('user_info')}</div>
        <div className="cometchat-user-details__header-icon" onClick={onHide} />
      </div>
      <div className="cometchat-user-details__content">
        <div className="cometchat-user-details__content-avatar">
          {/* <CometChatAvatar image={user.getAvatar?.()} name={user.getName()} /> */}
          {/* Avatar with click handler */}
          <div 
            onClick={handleAvatarClick}
              style={{
                  cursor: hasAvatar ? "pointer" : "default",
              }}
            >
            <CometChatAvatar image={user.getAvatar?.()} name={user.getName()} />
          </div>
          {/* Preview modal */}
          {isPreviewOpen && (
            <div
              className="preview-overlay"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#000",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
                flexDirection: "column",
              }}
            >
              {/* Header with back icon */}
              <div
                style={{
                  position: "absolute",
                  top: 15,
                  left: 15,
                  display: "flex",
                  alignItems: "center",
                  zIndex: 1001, // above image
                }}
              >
                <ArrowLeft
                  size={24}
                  color="#fff"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsPreviewOpen(false)}
                />
              </div>
              {/* Centered image */}
              <img
                src={user.getAvatar()}
                alt={`${user.getName()} preview`}
                style={{
                  maxHeight: "90%",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          )}
        </div>
        <div>
          <div className="cometchat-user-details__content-title">{user.getName()} {(loggedInUserRole?.getRole() === "manager" || loggedInUserRole?.getRole() === "lc") &&
            getRoleLabel(extendedUser.role)
          }</div>
          {showStatus && chatFeatures.coreMessagingExperience.userAndFriendsPresence && (
            <div className="cometchat-user-details__content-description">
              {getLocalizedString('message_header_status_' + user.getStatus?.())}
            </div>
          )}
        </div>

        <div className="cometchat-user-details__content-action">
          {actionItems.map((actionItem) => (
            <div
              key={actionItem.name}
              className={`${appState.isFreshChat && actionItem.name === 'Delete Chat' ? 'cometchat-user-details__content-action-item-disabled' : ''} cometchat-user-details__content-action-item`}
              onClick={() =>
                appState.isFreshChat && actionItem.name === 'Delete Chat' ? () => {} : onUserActionClick(actionItem)
              }
            >
              <div
                className={`cometchat-user-details__content-action-item-icon cometchat-user-details__content-action-item-icon-${actionItem.id}`}
                style={
                  actionItem.icon ? { WebkitMask: `url(${actionItem.icon}), center, center, no-repeat` } : undefined
                }
              />
              <div className="cometchat-user-details__content-action-item-text">{actionItem.name}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
